const styles = (theme) => ({
  field: {
    display: 'flex',
    justifyContent: 'space-between',
    maxWidth: 430,
  },
  label: {
    fontSize: '1rem',
  },
  number: {
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: `1px solid ${theme.palette.border.lightest}`,
    borderRight: 'none',
    height: 25,
    width: 25,
    '&:last-child': {
      borderRight: `1px solid ${theme.palette.border.lightest}`,
    },
  },
  copyLink: {
    marginTop: theme.spacing.unit * 2,
    fontSize: '1rem',
  },
});

export default styles;
